import Address from './Address';
import General from './General';
import Billing from './Billing';

export default {
  address: Address,
  general: General,
  billing: Billing,
};
